<template>
    <component v-if="currentPopup && !trimEditDisabled"
               :is="currentPopup.type"
    ></component>
</template>

<script>
    import { mapState, mapGetters } from 'vuex';
    import LinePopup from './LinePopup';
    import HemPopup from './HemPopup';
    import AnglePopup from './AnglePopup';

    export default {
        name: "Popup",

        components: {
            LinePopup,
            HemPopup,
            AnglePopup,
        },

        computed: {
            ...mapState('editPopup', [
                'currentPopup',
            ]),

            ...mapGetters('editor', [
                'trimEditDisabled',
            ]),

        },

    }
</script>

<style scoped>

</style>